import {Delete, FormPost, GET, POST, PUT} from "../util";

const debtorUrl = "api/trackpay/debtor";
const sellerUrl = "api/trackpay/seller";
const debtorContractsUrl = debtorUrl + "/contracts";
const debtorContractsListUrl = debtorUrl + "/contracts/list";
const debtorContractPdfUrl = debtorUrl + "/contract-pdf/";
const debtorLocationsByShipmentUrl = (id) => debtorUrl + `/shipments/${id}/shipments-units/previous-locations`;
const bankAccounts = debtorUrl + `/payments/bank-accounts`;
const sellerContractsUrl = sellerUrl + "/contracts";
const sellerCurrentContractsListUrl = sellerUrl + "/contracts/current/list";
const sellerSettledContractsListUrl = sellerUrl + "/contracts/settled/list";
const createContractAndSendToDebtorUrl = sellerUrl + "/contracts/save-and-send";
const sellerContractPdfUrl = sellerUrl + "/contract-pdf/";
const shipmentsUrl = (id) => sellerUrl + `/shipments/${id}`;
const changeContractStatusUrl = "/contracts/{id}/change-status/{status}";
const rejectContractUrl = (id) => `/contracts/${id}/reject`;
const supplierLocationsByShipmentUrl = (id) => sellerUrl + `/shipments/${id}/shipments-units/previous-locations`;
const singleSellerDocumentUpload = sellerUrl + "/seller-documents/file-upload";
const salesContractDebtorsUrl = sellerUrl + `/debtors`;

const trackPayApi = {
    debtor: {
        getContract: (id) => {
            return GET(`${debtorContractsUrl}/` + id);
        },
        getContracts: (params) => {
            return POST(`${debtorContractsListUrl}`, params);
        },
        changeStatus: (params = {}) => {
            let url = debtorUrl + `${changeContractStatusUrl}`.replace('{id}', params.id).replace('{status}', params.status);
            return POST(url);
        },
        reject: (params = {}) => {
            let url = debtorUrl + rejectContractUrl(params.id);
            return POST(url, params);
        },
        deleteContract: (id) => {
            return Delete(`${debtorContractsUrl}/` + id);
        },
        getGeneratedContractPdf: (id) => {
            return GET(`${debtorContractPdfUrl}` + id)
        },
        getLocationsByShipment: (id) => {
            return GET(debtorLocationsByShipmentUrl(id));
        },
        getBankAccountsForPayment: () => {
            return GET(bankAccounts);
        }
    },
    seller: {
        getContract: (id) => {
            return GET(`${sellerContractsUrl}/` + id);
        },
        getCurrentContracts: (params) => {
            return POST(`${sellerCurrentContractsListUrl}`, params);
        },
        getSettledContracts: (params) => {
            return POST(`${sellerSettledContractsListUrl}`, params);
        },
        createContract: (params = {}) => {
            return POST(`${sellerContractsUrl}`, params);
        },
        createContractAndSendToDebtor: (params = {}) => {
            return POST(`${createContractAndSendToDebtorUrl}`, params);
        },
        updateContract: (params = {}) => {
            return PUT(`${sellerContractsUrl}`, params);
        },
        deleteContract: (id) => {
            return Delete(`${sellerContractsUrl}/` + id);
        },
        getProductGroups: (params) => {
            return GET(`${sellerUrl}/product-groups`, params);
        },
        getGeneratedContractPdf: (id) => {
            return GET(`${sellerContractPdfUrl}` + id)
        },
        getDeviceProfiles: (params) => {
            return PUT(`${sellerUrl}/device-profiles`, params);
        },
        startShipment: (id) => {
            return POST(shipmentsUrl(id));
        },
        getLocationsByShipment: (id) => {
            return GET(supplierLocationsByShipmentUrl(id));
        },
        uploadSingleSellerDocument: (params = {}) => {
            return FormPost(`${singleSellerDocumentUpload}`, params);
        },
        getSalesContractDebtorsUrl: () => {
            return GET(`${salesContractDebtorsUrl}`)
        }
    }
};

export {
    trackPayApi
};